// Angular imports
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

// 3rd party imports
import { classToPlain, plainToClass } from 'class-transformer';

// RxJs imports
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

// Model imports
import { WorkFlowParametersDto } from '../../shared-workflow-module/_models/workflow-parameters-dto';
import { WFEDeniedStepEditorResultDto } from '../_models/workflow-denied-step/wfe-denied-step-editor-result-dto';
import { WFEWorkflowRawDto } from '../../shared-workflow-module/_models/wfe-workflow-raw-dto';

// constant imports
import { URLConstants } from '../../_constants/url-constants';

@Injectable({
    providedIn: 'root'
})
export class WorkflowDeniedService {
    constructor(private readonly httpClient: HttpClient) {}

    getWorflowDeniedEditor(baseParams: WorkFlowParametersDto): Observable<WFEDeniedStepEditorResultDto> {
        const url = `${URLConstants.ccWorkflowEditorBaseApiUrl}denied/editor${baseParams.getQueryString()}`;

        return this.httpClient
            .get(url)
            .pipe(map((response: any) => plainToClass(WFEDeniedStepEditorResultDto, response)));
    }

    advanceFromDenied(baseParams: WFEWorkflowRawDto): Observable<any> {
        return this.httpClient.put(
            `${URLConstants.ccWorkflowEditorBaseApiUrl}denied/advance`,
            classToPlain(baseParams)
        );
    }
}
